export const getCountries = [
  {
    name: 'Afghanistan',
    code: 'AF',
  },
  {
    name: 'Åland Islands',
    code: 'AX',
  },
  {
    name: 'Albania',
    code: 'AL',
  },
  {
    name: 'Algeria',
    code: 'DZ',
  },
  {
    name: 'American Samoa',
    code: 'AS',
  },
  {
    name: 'Andorra',
    code: 'AD',
  },
  {
    name: 'Angola',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
  },
  {
    name: 'Argentina',
    code: 'AR',
  },
  {
    name: 'Armenia',
    code: 'AM',
  },
  {
    name: 'Aruba',
    code: 'AW',
  },
  {
    name: 'Australia',
    code: 'AU',
  },
  {
    name: 'Austria',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
  },
  {
    name: 'Barbados',
    code: 'BB',
  },
  {
    name: 'Belarus',
    code: 'BY',
  },
  {
    name: 'Belgium',
    code: 'BE',
  },
  {
    name: 'Belize',
    code: 'BZ',
  },
  {
    name: 'Benin',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    code: 'BT',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    code: 'BO',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    code: 'BQ',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
  },
  {
    name: 'Botswana',
    code: 'BW',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
  },
  {
    name: 'Brazil',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
  },
  {
    name: 'Virgin Islands (British)',
    code: 'VG',
  },
  {
    name: 'Virgin Islands (U.S.)',
    code: 'VI',
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
  },
  {
    name: 'Burundi',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    code: 'CM',
  },
  {
    name: 'Canada',
    code: 'CA',
  },
  {
    name: 'Cabo Verde',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
  },
  {
    name: 'Chad',
    code: 'TD',
  },
  {
    name: 'Chile',
    code: 'CL',
  },
  {
    name: 'China',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
  },
  {
    name: 'Colombia',
    code: 'CO',
  },
  {
    name: 'Comoros',
    code: 'KM',
  },
  {
    name: 'Congo',
    code: 'CG',
  },
  {
    name: 'Congo (Democratic Republic of the)',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
  },
  {
    name: 'Croatia',
    code: 'HR',
  },
  {
    name: 'Cuba',
    code: 'CU',
  },
  {
    name: 'Curaçao',
    code: 'CW',
  },
  {
    name: 'Cyprus',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    code: 'EC',
  },
  {
    name: 'Egypt',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    code: 'ER',
  },
  {
    name: 'Estonia',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
  },
  {
    name: 'Fiji',
    code: 'FJ',
  },
  {
    name: 'Finland',
    code: 'FI',
  },
  {
    name: 'France',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
  },
  {
    name: 'Gabon',
    code: 'GA',
  },
  {
    name: 'Gambia',
    code: 'GM',
  },
  {
    name: 'Georgia',
    code: 'GE',
  },
  {
    name: 'Germany',
    code: 'DE',
  },
  {
    name: 'Ghana',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
  },
  {
    name: 'Greece',
    code: 'GR',
  },
  {
    name: 'Greenland',
    code: 'GL',
  },
  {
    name: 'Grenada',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
  },
  {
    name: 'Guam',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    code: 'GG',
  },
  {
    name: 'Guinea',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
  },
  {
    name: 'Guyana',
    code: 'GY',
  },
  {
    name: 'Haiti',
    code: 'HT',
  },
  {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
  },
  {
    name: 'Vatican City',
    code: 'VA',
  },
  {
    name: 'Honduras',
    code: 'HN',
  },
  {
    name: 'Hungary',
    code: 'HU',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
  },
  {
    name: 'Iceland',
    code: 'IS',
  },
  {
    name: 'India',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    code: 'ID',
  },
  {
    name: 'Ivory Coast',
    code: 'CI',
  },
  {
    name: 'Iran (Islamic Republic of)',
    code: 'IR',
  },
  {
    name: 'Iraq',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
  },
  {
    name: 'Israel',
    code: 'IL',
  },
  {
    name: 'Italy',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    code: 'JM',
  },
  {
    name: 'Japan',
    code: 'JP',
  },
  {
    name: 'Jersey',
    code: 'JE',
  },
  {
    name: 'Jordan',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    code: 'KI',
  },
  {
    name: 'Kuwait',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    name: 'Lao People Democratic Republic',
    code: 'LA',
  },
  {
    name: 'Latvia',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    code: 'LS',
  },
  {
    name: 'Liberia',
    code: 'LR',
  },
  {
    name: 'Libya',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
  },
  {
    name: 'Macao',
    code: 'MO',
  },
  {
    name: 'North Macedonia',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    code: 'MG',
  },
  {
    name: 'Malawi',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    code: 'MY',
  },
  {
    name: 'Maldives',
    code: 'MV',
  },
  {
    name: 'Mali',
    code: 'ML',
  },
  {
    name: 'Malta',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
  },
  {
    name: 'Martinique',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    code: 'YT',
  },
  {
    name: 'Mexico',
    code: 'MX',
  },
  {
    name: 'Micronesia (Federated States of)',
    code: 'FM',
  },
  {
    name: 'Moldova (Republic of)',
    code: 'MD',
  },
  {
    name: 'Monaco',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    code: 'MN',
  },
  {
    name: 'Montenegro',
    code: 'ME',
  },
  {
    name: 'Montserrat',
    code: 'MS',
  },
  {
    name: 'Morocco',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    code: 'MM',
  },
  {
    name: 'Namibia',
    code: 'NA',
  },
  {
    name: 'Nauru',
    code: 'NR',
  },
  {
    name: 'Nepal',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    code: 'NL',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
  },
  {
    name: 'Niger',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    code: 'NG',
  },
  {
    name: 'Niue',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
  },
  {
    name: 'Korea (Democratic People Republic of)',
    code: 'KP',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
  {
    name: 'Norway',
    code: 'NO',
  },
  {
    name: 'Oman',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    code: 'PK',
  },
  {
    name: 'Palau',
    code: 'PW',
  },
  {
    name: 'Palestine, State of',
    code: 'PS',
  },
  {
    name: 'Panama',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    code: 'PY',
  },
  {
    name: 'Peru',
    code: 'PE',
  },
  {
    name: 'Philippines',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    code: 'PN',
  },
  {
    name: 'Poland',
    code: 'PL',
  },
  {
    name: 'Portugal',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    name: 'Qatar',
    code: 'QA',
  },
  {
    name: 'Republic of Kosovo',
    code: 'XK',
  },
  {
    name: 'Réunion',
    code: 'RE',
  },
  {
    name: 'Romania',
    code: 'RO',
  },
  {
    name: 'Russian Federation',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    code: 'RW',
  },
  {
    name: 'Saint Barthélemy',
    code: 'BL',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
  },
  {
    name: 'Saint Martin (French part)',
    code: 'MF',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
  },
  {
    name: 'Samoa',
    code: 'WS',
  },
  {
    name: 'San Marino',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
  },
  {
    name: 'Senegal',
    code: 'SN',
  },
  {
    name: 'Serbia',
    code: 'RS',
  },
  {
    name: 'Seychelles',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
  },
  {
    name: 'Singapore',
    code: 'SG',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    code: 'SX',
  },
  {
    name: 'Slovakia',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
  },
  {
    name: 'Somalia',
    code: 'SO',
  },
  {
    name: 'South Africa',
    code: 'ZA',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
  },
  {
    name: 'Korea (Republic of)',
    code: 'KR',
  },
  {
    name: 'Spain',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
  },
  {
    name: 'Sudan',
    code: 'SD',
  },
  {
    name: 'South Sudan',
    code: 'SS',
  },
  {
    name: 'Suriname',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
  },
  {
    name: 'Taiwan',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
  },
  {
    name: 'Togo',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    code: 'TK',
  },
  {
    name: 'Tonga',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    code: 'TN',
  },
  {
    name: 'Turkey',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
  },
  {
    name: 'Uganda',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    code: 'GB',
  },
  {
    name: 'United States of America',
    code: 'US',
  },
  {
    name: 'Uruguay',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    code: 'VE',
  },
  {
    name: 'Vietnam',
    code: 'VN',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
  },
  {
    name: 'Yemen',
    code: 'YE',
  },
  {
    name: 'Zambia',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
  },
]

export const getRaces = [
  {
    id: 1,
    description: 'Branco',
    description_en: 'White',
    description_es: 'Blanco',
  },
  {
    id: 2,
    description: 'Preto',
    description_en: 'Black',
    description_es: 'Negro',
  },
  {
    id: 3,
    description: 'Pardo',
    description_en: 'Brown',
    description_es: 'Marrón',
  },
  {
    id: 4,
    description: 'Indígena',
    description_en: 'Indigenous',
    description_es: 'Indígena',
  },
  {
    id: 5,
    description: 'Amarelo (Oriental)',
    description_en: 'Yellow (Eastern)',
    description_es: 'Amarillo (Este)',
  },
  {
    id: 6,
    description: 'Prefiro não declarar',
    description_en: 'I prefer not to declare',
    description_es: 'Prefiero no declarar',
  },
] as any

export const getGenders = [
  {
    id: 1,
    description: 'Homem Cisgênero',
    description_en: 'Cisgender Man',
    description_es: 'Hombre Cisgénero',
  },
  {
    id: 2,
    description: 'Mulher Cisgênero',
    description_en: 'Cisgender Woman',
    description_es: 'Mujer Cisgénero',
  },
  {
    id: 3,
    description: 'Homem Trans',
    description_en: 'Trans Male',
    description_es: 'Hombre Trans',
  },
  {
    id: 4,
    description: 'Mulher Trans',
    description_en: 'Trans Woman',
    description_es: 'Mujer Trans',
  },
  {
    id: 5,
    description: 'Não-binário',
    description_en: 'Non-binary',
    description_es: 'No binario',
  },
  {
    id: 6,
    description: 'Prefiro não responder',
    description_en: 'I prefer to not answer',
    description_es: 'Prefiero no responder',
  },
  {
    id: 7,
    description: 'Outros',
    description_en: 'Others',
    description_es: 'Otros',
  },
]

export const getCategoriesWithChildren = [
  {
    id: 252,
    description: 'APPs',
    description_en: 'APPs',
    description_es: 'APPs',
    emoji: '📱',
    parentId: null,
    children: [],
  },
  {
    id: 51,
    description: 'Ativismo e Causas Sociais',
    description_en: 'Activism & Social Causes',
    description_es: 'Activismo y causas sociales',
    emoji: '✊',
    parentId: null,
    children: [
      {
        id: 52,
        description: 'Acessibilidade e Inclusão',
        description_en: 'Accessibility & Inclusion',
        description_es: 'Accesibilidad e inclusión',
        emoji: null,
        parentId: 51,
      },
      {
        id: 235,
        description: 'Anti Racismo',
        description_en: 'Anti Racism',
        description_es: 'Anti Racismo',
        emoji: null,
        parentId: 51,
      },
      {
        id: 229,
        description: 'Auto Aceitação',
        description_en: 'Auto Acceptance',
        description_es: 'Auto Aceptación',
        emoji: null,
        parentId: 51,
      },
      {
        id: 231,
        description: 'Direito Dos Animais',
        description_en: 'Law Of Animals',
        description_es: 'Defensa Animal',
        emoji: null,
        parentId: 51,
      },
      {
        id: 48,
        description: 'Diversidade e Empoderamento',
        description_en: 'Diversity & Empowerment',
        description_es: 'Diversidad y empoderamiento',
        emoji: null,
        parentId: 51,
      },
      {
        id: 230,
        description: 'Diversidade Racial',
        description_en: 'Racial diversity',
        description_es: 'Diversidad racial',
        emoji: null,
        parentId: 51,
      },
      {
        id: 232,
        description: 'Feminismo',
        description_en: 'Feminism',
        description_es: 'Feminismo',
        emoji: null,
        parentId: 51,
      },
      {
        id: 228,
        description: 'Filantropia',
        description_en: 'Philanthropy',
        description_es: 'Filantropía',
        emoji: null,
        parentId: 51,
      },
      {
        id: 233,
        description: 'LGBTQIA+',
        description_en: 'LGBTQIA+',
        description_es: 'LGBTQIA+',
        emoji: null,
        parentId: 51,
      },
      {
        id: 238,
        description: 'Mais Beleza, Menos Lixo e Amazônia Viva',
        description_en: 'More Beauty, Less Trash And Amazon Viva',
        description_es: 'Más Beauty, Menos Basura Y Amazon Viva',
        emoji: null,
        parentId: 51,
      },
      {
        id: 236,
        description: 'Midsize',
        description_en: 'Midsize',
        description_es: 'Tamaño Medio',
        emoji: null,
        parentId: 51,
      },
      {
        id: 234,
        description: 'ONG',
        description_en: 'NGO',
        description_es: 'ONG',
        emoji: null,
        parentId: 51,
      },
      {
        id: 239,
        description: 'Pessoas com Deficiência',
        description_en: 'Disabled People',
        description_es: 'Personas Con Deficiencia',
        emoji: null,
        parentId: 51,
      },
      {
        id: 237,
        description: 'Plus Size',
        description_en: 'Plus Size',
        description_es: 'Talla Extra',
        emoji: null,
        parentId: 51,
      },
      {
        id: 240,
        description: 'Sustentabilidade',
        description_en: 'Sustainability',
        description_es: 'Sustentabilidad',
        emoji: null,
        parentId: 51,
      },
    ],
  },
  {
    id: 4,
    description: 'Automotivo',
    description_en: 'Automotive',
    description_es: 'Automotor',
    emoji: '🏎️',
    parentId: null,
    children: [
      {
        id: 171,
        description: 'Automoveis',
        description_en: 'Automobiles',
        description_es: 'Automóviles',
        emoji: null,
        parentId: 4,
      },
      {
        id: 175,
        description: 'Aviões',
        description_en: 'Airplanes',
        description_es: 'Aviones',
        emoji: null,
        parentId: 4,
      },
      {
        id: 172,
        description: 'Barcos',
        description_en: 'Boats',
        description_es: 'Barcos',
        emoji: null,
        parentId: 4,
      },
      {
        id: 174,
        description: 'Caminhões',
        description_en: 'Trucks',
        description_es: 'Camiones',
        emoji: null,
        parentId: 4,
      },
      {
        id: 176,
        description: 'Helicópteros',
        description_en: 'Helicopters',
        description_es: 'Helicópteros',
        emoji: null,
        parentId: 4,
      },
      {
        id: 177,
        description: 'Manutenção/Mecânico',
        description_en: 'Maintenance / Mechanical',
        description_es: 'Mantenimiento / Mecánico',
        emoji: null,
        parentId: 4,
      },
      {
        id: 173,
        description: 'Motocicletas',
        description_en: 'Motorcycles',
        description_es: 'Motocicletas',
        emoji: null,
        parentId: 4,
      },
    ],
  },
  {
    id: 5,
    description: 'Bebidas',
    description_en: 'Drinks',
    description_es: 'Bebidas',
    emoji: '🍹',
    parentId: null,
    children: [
      {
        id: 98,
        description: 'Bares',
        description_en: 'Bars',
        description_es: 'Barras',
        emoji: null,
        parentId: 5,
      },
      {
        id: 102,
        description: 'Cafés',
        description_en: 'Cafes',
        description_es: 'Cafés',
        emoji: null,
        parentId: 5,
      },
      {
        id: 99,
        description: 'Cerveja e Chopp',
        description_en: 'Beer and Chopp',
        description_es: 'Cerveza Y Chopp',
        emoji: null,
        parentId: 5,
      },
      {
        id: 105,
        description: 'Destilados',
        description_en: 'Distillates',
        description_es: 'Destilados',
        emoji: null,
        parentId: 5,
      },
      {
        id: 100,
        description: 'Drinks',
        description_en: 'Drinks',
        description_es: 'Bebidas',
        emoji: null,
        parentId: 5,
      },
      {
        id: 104,
        description: 'Fermentados',
        description_en: 'Fermented',
        description_es: 'Fermentado',
        emoji: null,
        parentId: 5,
      },
      {
        id: 103,
        description: 'Não alcoólicos',
        description_en: 'Non-alcoholic',
        description_es: 'No Alcohólico',
        emoji: null,
        parentId: 5,
      },
      {
        id: 101,
        description: 'Vinhos',
        description_en: 'Wines',
        description_es: 'Vinos',
        emoji: null,
        parentId: 5,
      },
    ],
  },
  {
    id: 11,
    description: 'Beleza',
    description_en: 'Beauty',
    description_es: 'Belleza',
    emoji: '💅',
    parentId: null,
    children: [
      {
        id: 66,
        description: 'Barba',
        description_en: 'Beard',
        description_es: 'Barba',
        emoji: null,
        parentId: 11,
      },
      {
        id: 63,
        description: 'Cabelo',
        description_en: 'Hair',
        description_es: 'Cabello',
        emoji: null,
        parentId: 11,
      },
      {
        id: 71,
        description: 'Corpo',
        description_en: 'Body',
        description_es: 'Cuerpo',
        emoji: null,
        parentId: 11,
      },
      {
        id: 65,
        description: 'Cuidados com o corpo',
        description_en: 'Cares with the body',
        description_es: 'Cuidados Con El Cuerpo',
        emoji: null,
        parentId: 11,
      },
      {
        id: 74,
        description: 'Cuidados masculinos',
        description_en: 'Male Care',
        description_es: 'El Cuidado De Los Hombres',
        emoji: null,
        parentId: 11,
      },
      {
        id: 62,
        description: 'Dermocosméticos',
        description_en: 'Dermocosméticos',
        description_es: 'Dermocosmética',
        emoji: null,
        parentId: 11,
      },
      {
        id: 73,
        description: 'Infantil',
        description_en: 'Infant',
        description_es: 'Infantil',
        emoji: null,
        parentId: 11,
      },
      {
        id: 64,
        description: 'Maquiagem',
        description_en: 'Makeup',
        description_es: 'Maquillaje',
        emoji: null,
        parentId: 11,
      },
      {
        id: 70,
        description: 'Perfumaria',
        description_en: 'Perfumery',
        description_es: 'Perfumería',
        emoji: null,
        parentId: 11,
      },
      {
        id: 72,
        description: 'Presentes',
        description_en: 'Gifts',
        description_es: 'Regalos',
        emoji: null,
        parentId: 11,
      },
      {
        id: 67,
        description: 'Rosto e Skin care',
        description_en: 'Face and Skin care',
        description_es: 'Rosto Y Cuidado De La Piel',
        emoji: null,
        parentId: 11,
      },
      {
        id: 68,
        description: 'Tratamentos Estéticos',
        description_en: 'Aesthetic treatments',
        description_es: 'Tratamientos Estéticos',
        emoji: null,
        parentId: 11,
      },
      {
        id: 69,
        description: 'Unhas',
        description_en: 'Nails',
        description_es: 'Clavos',
        emoji: null,
        parentId: 11,
      },
    ],
  },
  {
    id: 12,
    description: 'Brinquedos',
    description_en: 'Toys',
    description_es: 'Juguetes',
    emoji: '🧸',
    parentId: null,
    children: [
      {
        id: 242,
        description: 'Brinquedos Educativos',
        description_en: 'Educative Toys',
        description_es: 'Juguetes Educativos',
        emoji: null,
        parentId: 12,
      },
      {
        id: 241,
        description: 'Brinquedos Infantis',
        description_en: 'Juguetes De Los Niños',
        description_es: 'Juguetes De Los Niños',
        emoji: null,
        parentId: 12,
      },
    ],
  },
  {
    id: 2,
    description: 'Casa e Construção',
    description_en: 'Home and Construction',
    description_es: 'Casa y construcción',
    emoji: '🛠️',
    parentId: null,
    children: [
      {
        id: 180,
        description: 'Aluguel',
        description_en: 'Rent',
        description_es: 'Alquilar',
        emoji: null,
        parentId: 2,
      },
      {
        id: 178,
        description: 'Arquitetura',
        description_en: 'Architecture',
        description_es: 'Arquitectura',
        emoji: null,
        parentId: 2,
      },
      {
        id: 54,
        description: 'Construção',
        description_en: 'Construction',
        description_es: 'Construcción',
        emoji: null,
        parentId: 2,
      },
      {
        id: 186,
        description: 'Decoração e Design De Interiores',
        description_en: 'Decoration and Interior Design',
        description_es: 'Decoración Y Diseño De Interiores',
        emoji: null,
        parentId: 2,
      },
      {
        id: 179,
        description: 'Engenharia',
        description_en: 'Engineering',
        description_es: 'Ingenieria',
        emoji: null,
        parentId: 2,
      },
      {
        id: 183,
        description: 'Jardinagem e Paisagismo',
        description_en: 'Gardening and Landscaping',
        description_es: 'Jardinería Y Paisajismo',
        emoji: null,
        parentId: 2,
      },
      {
        id: 182,
        description: 'Móveis',
        description_en: 'Furniture',
        description_es: 'Mueble',
        emoji: null,
        parentId: 2,
      },
      {
        id: 184,
        description: 'Reforma',
        description_en: 'Remodeling',
        description_es: 'Remodelación',
        emoji: null,
        parentId: 2,
      },
      {
        id: 185,
        description: 'Urbanismo',
        description_en: 'Urbanism',
        description_es: 'Urbanismo',
        emoji: null,
        parentId: 2,
      },
      {
        id: 181,
        description: 'Venda',
        description_en: 'Sale',
        description_es: 'Venta',
        emoji: null,
        parentId: 2,
      },
    ],
  },
  {
    id: 243,
    description: 'Celebridade',
    description_en: 'Celebrity',
    description_es: 'Celebridad',
    emoji: '📸',
    parentId: null,
    children: [
      {
        id: 244,
        description: 'Fofocas',
        description_en: 'Gossip',
        description_es: 'Chisme',
        emoji: null,
        parentId: 243,
      },
    ],
  },
  {
    id: 13,
    description: 'Cultura',
    description_en: 'Culture',
    description_es: 'Cultura',
    emoji: '🎭',
    parentId: null,
    children: [
      {
        id: 143,
        description: 'Animação',
        description_en: 'Animation',
        description_es: 'Animación',
        emoji: null,
        parentId: 13,
      },
      {
        id: 138,
        description: 'Artes',
        description_en: 'Art',
        description_es: 'Artes',
        emoji: null,
        parentId: 13,
      },
      {
        id: 139,
        description: 'Artista',
        description_en: 'Artist',
        description_es: 'Artista',
        emoji: null,
        parentId: 13,
      },
      {
        id: 141,
        description: 'Comédia',
        description_en: 'Comedy',
        description_es: 'Comedia',
        emoji: null,
        parentId: 13,
      },
      {
        id: 147,
        description: 'Dança',
        description_en: 'Dance',
        description_es: 'Danza',
        emoji: null,
        parentId: 13,
      },
      {
        id: 144,
        description: 'Desenho',
        description_en: 'Design',
        description_es: 'Diseño',
        emoji: null,
        parentId: 13,
      },
      {
        id: 142,
        description: 'Escritores',
        description_en: 'Writers',
        description_es: 'Escritores',
        emoji: null,
        parentId: 13,
      },
      {
        id: 59,
        description: 'Livro',
        description_en: 'Books & Literature',
        description_es: 'Libros y literatura',
        emoji: null,
        parentId: 13,
      },
      {
        id: 145,
        description: 'Pintura',
        description_en: 'Painting',
        description_es: 'Cuadro',
        emoji: null,
        parentId: 13,
      },
      {
        id: 140,
        description: 'Podcasts',
        description_en: 'Podcasts',
        description_es: 'Podcasts',
        emoji: null,
        parentId: 13,
      },
      {
        id: 146,
        description: 'Teatro',
        description_en: 'Theater',
        description_es: 'Teatro',
        emoji: null,
        parentId: 13,
      },
    ],
  },
  {
    id: 45,
    description: 'Cultura nerd',
    description_en: 'Geek culture',
    description_es: 'Cultura friki',
    emoji: '🤓',
    parentId: null,
    children: [],
  },
  {
    id: 46,
    description: 'DIY e Artesanato',
    description_en: 'DIY and Crafts',
    description_es: 'Bricolaje y manualidades',
    emoji: '🎨',
    parentId: null,
    children: [],
  },
  {
    id: 55,
    description: 'E-commerce',
    description_en: 'Ecommerce',
    description_es: 'Comercio electrónico',
    emoji: '🛍️',
    parentId: null,
    children: [],
  },
  {
    id: 53,
    description: 'Educação',
    description_en: 'Education',
    description_es: 'Educación',
    emoji: '🎓',
    parentId: null,
    children: [
      {
        id: 197,
        description: 'Administração',
        description_en: 'Management',
        description_es: 'Gestión',
        emoji: null,
        parentId: 53,
      },
      {
        id: 195,
        description: 'Aréa Medica',
        description_en: 'Medical',
        description_es: 'Médico',
        emoji: null,
        parentId: 53,
      },
      {
        id: 190,
        description: 'Concurso',
        description_en: 'Concurso',
        description_es: 'Concurso',
        emoji: null,
        parentId: 53,
      },
      {
        id: 196,
        description: 'Direito',
        description_en: 'Right',
        description_es: 'Abogacía',
        emoji: null,
        parentId: 53,
      },
      {
        id: 187,
        description: 'Educação Infantil',
        description_en: 'Child education',
        description_es: 'Educación Infantil',
        emoji: null,
        parentId: 53,
      },
      {
        id: 193,
        description: 'Escola',
        description_en: 'School',
        description_es: 'Colegio',
        emoji: null,
        parentId: 53,
      },
      {
        id: 188,
        description: 'Graduação',
        description_en: 'University graduate',
        description_es: 'Graduado Universitario',
        emoji: null,
        parentId: 53,
      },
      {
        id: 191,
        description: 'Intercâmbio',
        description_en: 'Exchange',
        description_es: 'Intercambio',
        emoji: null,
        parentId: 53,
      },
      {
        id: 194,
        description: 'Linguas Estrangeiras',
        description_en: 'Foreign languages',
        description_es: 'Idiomas Extranjeros',
        emoji: null,
        parentId: 53,
      },
      {
        id: 189,
        description: 'Pós-Graduação',
        description_en: 'Postgraduate studies',
        description_es: 'Posgraduación',
        emoji: null,
        parentId: 53,
      },
      {
        id: 192,
        description: 'Vestibular',
        description_en: 'Entrance exam',
        description_es: 'Examen De Admision',
        emoji: null,
        parentId: 53,
      },
    ],
  },
  {
    id: 49,
    description: 'Entretenimento',
    description_en: 'Entertainment',
    description_es: 'Entretenimiento',
    emoji: '🎬',
    parentId: null,
    children: [
      {
        id: 90,
        description: 'Challenge',
        description_en: 'Challenge',
        description_es: 'Desafío',
        emoji: null,
        parentId: 49,
      },
      {
        id: 87,
        description: 'Cinema',
        description_en: 'Movie theater',
        description_es: 'Cine',
        emoji: null,
        parentId: 49,
      },
      {
        id: 88,
        description: 'E-Sports',
        description_en: 'E-Sports',
        description_es: 'E-Sports',
        emoji: null,
        parentId: 49,
      },
      {
        id: 89,
        description: 'Humorista',
        description_en: 'Humorist',
        description_es: 'Humorista',
        emoji: null,
        parentId: 49,
      },
      {
        id: 91,
        description: 'Novela',
        description_en: 'Novel',
        description_es: 'Novela',
        emoji: null,
        parentId: 49,
      },
      {
        id: 92,
        description: 'Reality show',
        description_en: 'Reality show',
        description_es: 'Reality show',
        emoji: null,
        parentId: 49,
      },
      {
        id: 15,
        description: 'Séries e Filmes',
        description_en: 'Series and movies',
        description_es: 'Series y peliculas',
        emoji: null,
        parentId: 49,
      },
    ],
  },
  {
    id: 16,
    description: 'Esportes',
    description_en: 'Sports',
    description_es: 'Deportes',
    emoji: '🚴‍♀️',
    parentId: null,
    children: [
      {
        id: 148,
        description: 'Amador',
        description_en: 'Amateur',
        description_es: 'Aficionado',
        emoji: null,
        parentId: 16,
      },
      {
        id: 150,
        description: 'Artes Marciais',
        description_en: 'Martial arts',
        description_es: 'Artes Marciales',
        emoji: null,
        parentId: 16,
      },
      {
        id: 149,
        description: 'Atletas',
        description_en: 'Athletes',
        description_es: 'Atletas',
        emoji: null,
        parentId: 16,
      },
      {
        id: 156,
        description: 'Bodybuilding',
        description_en: 'Bodybuilding',
        description_es: 'Culturismo',
        emoji: null,
        parentId: 16,
      },
      {
        id: 153,
        description: 'Corrida',
        description_en: 'Race',
        description_es: 'Raza',
        emoji: null,
        parentId: 16,
      },
      {
        id: 154,
        description: 'Crossfit',
        description_en: 'Crossfit',
        description_es: 'Crossfit',
        emoji: null,
        parentId: 16,
      },
      {
        id: 155,
        description: 'Educador Físico',
        description_en: 'Physical educator',
        description_es: 'Educador Físico',
        emoji: null,
        parentId: 16,
      },
      {
        id: 151,
        description: 'Esportes Coletivos',
        description_en: 'Collective sports',
        description_es: 'Deportes Colectivos',
        emoji: null,
        parentId: 16,
      },
      {
        id: 152,
        description: 'Esportes Individuais',
        description_en: 'Individual Sports',
        description_es: 'Deportes Individuales',
        emoji: null,
        parentId: 16,
      },
      {
        id: 18,
        description: 'Fitness',
        description_en: 'Fitness',
        description_es: 'Aptitud física',
        emoji: null,
        parentId: 16,
      },
      {
        id: 157,
        description: 'Yoga',
        description_en: 'Yoga',
        description_es: 'Yoga',
        emoji: null,
        parentId: 16,
      },
    ],
  },
  {
    id: 93,
    description: 'Familia',
    description_en: 'Family',
    description_es: 'Familia',
    emoji: '👩‍👩‍👧‍👦',
    parentId: null,
    children: [
      {
        id: 96,
        description: 'Adolescentes',
        description_en: 'Teens',
        description_es: 'Adolescentes',
        emoji: null,
        parentId: 93,
      },
      {
        id: 94,
        description: 'Bebês',
        description_en: 'Babies',
        description_es: 'Bebés',
        emoji: null,
        parentId: 93,
      },
      {
        id: 95,
        description: 'Crianças',
        description_en: 'Kids',
        description_es: 'Niños',
        emoji: null,
        parentId: 93,
      },
      {
        id: 47,
        description: 'Maternidade',
        description_en: 'Motherhood',
        description_es: 'Maternidad',
        emoji: null,
        parentId: 93,
      },
      {
        id: 60,
        description: 'Paternidade',
        description_en: 'Fatherhood',
        description_es: 'Paternidad',
        emoji: null,
        parentId: 93,
      },
      {
        id: 7,
        description: 'Relacionamentos',
        description_en: 'Relationships',
        description_es: 'Relaciones',
        emoji: null,
        parentId: 93,
      },
      {
        id: 97,
        description: 'Terceira Idade',
        description_en: 'Third Age',
        description_es: 'Tercera Edad',
        emoji: null,
        parentId: 93,
      },
    ],
  },
  {
    id: 58,
    description: 'Finanças e Seguros',
    description_en: 'Finances',
    description_es: 'Finanzas y Seguros',
    emoji: '💵',
    parentId: null,
    children: [
      {
        id: 83,
        description: 'Criptomoeda',
        description_en: 'Cryptocurrency',
        description_es: 'Criptomoneda',
        emoji: null,
        parentId: 58,
      },
      {
        id: 84,
        description: 'Economia',
        description_en: 'Economy',
        description_es: 'Economía',
        emoji: null,
        parentId: 58,
      },
      {
        id: 85,
        description: 'Educação Financeira',
        description_en: 'Financial education',
        description_es: 'Educación financiera',
        emoji: null,
        parentId: 58,
      },
      {
        id: 86,
        description: 'Investimentos',
        description_en: 'Investments',
        description_es: 'Inversiones',
        emoji: null,
        parentId: 58,
      },
    ],
  },
  {
    id: 21,
    description: 'Games',
    description_en: 'Games',
    description_es: 'Juegos',
    emoji: '🎮',
    parentId: null,
    children: [
      {
        id: 167,
        description: 'Board Games',
        description_en: 'Board Games',
        description_es: 'Juegos De Mesa',
        emoji: null,
        parentId: 21,
      },
      {
        id: 166,
        description: 'Video games',
        description_en: 'Video games',
        description_es: 'Juegos de vídeo',
        emoji: null,
        parentId: 21,
      },
    ],
  },
  {
    id: 10,
    description: 'Gastronomia e Alimentos',
    description_en: 'Gastronomy & Food',
    description_es: 'Gastronomía y alimentación',
    emoji: '👩‍🍳',
    parentId: null,
    children: [
      {
        id: 108,
        description: 'Alimentação Saudavel',
        description_en: 'Healthy eating',
        description_es: 'Alimentación Saludable',
        emoji: null,
        parentId: 10,
      },
      {
        id: 61,
        description: 'Carnes',
        description_en: 'Meat',
        description_es: 'Carne',
        emoji: null,
        parentId: 10,
      },
      {
        id: 110,
        description: 'Chef de Cozinha',
        description_en: 'Chef Kitchen',
        description_es: 'Chef de Cocina',
        emoji: null,
        parentId: 10,
      },
      {
        id: 111,
        description: 'Confeitaria',
        description_en: 'Confectionery',
        description_es: 'Confitería',
        emoji: null,
        parentId: 10,
      },
      {
        id: 106,
        description: 'Dicas de Restaurantes',
        description_en: 'Restaurants Tips',
        description_es: 'Consejos de restaurante',
        emoji: null,
        parentId: 10,
      },
      {
        id: 117,
        description: 'Fast Foods e Restaurantes',
        description_en: 'Fast Foods and Restaurants',
        description_es: 'Comidas rápidas y restaurantes.',
        emoji: null,
        parentId: 10,
      },
      {
        id: 112,
        description: 'Hambúrguer',
        description_en: 'Hamburger',
        description_es: 'Hamburguesa',
        emoji: null,
        parentId: 10,
      },
      {
        id: 109,
        description: 'Orgânicos',
        description_en: 'Organic',
        description_es: 'Orgánico',
        emoji: null,
        parentId: 10,
      },
      {
        id: 113,
        description: 'Panificação',
        description_en: 'Bakery',
        description_es: 'Panadería',
        emoji: null,
        parentId: 10,
      },
      {
        id: 107,
        description: 'Receitas',
        description_en: 'Recipes',
        description_es: 'Recetas',
        emoji: null,
        parentId: 10,
      },
      {
        id: 116,
        description: 'Tábua de frios',
        description_en: 'Board cold',
        description_es: 'Tabla De Frios',
        emoji: null,
        parentId: 10,
      },
      {
        id: 114,
        description: 'Vegana',
        description_en: 'Vegan',
        description_es: 'Vegano',
        emoji: null,
        parentId: 10,
      },
      {
        id: 115,
        description: 'Vegetariana',
        description_en: 'Vegetarian',
        description_es: 'Vegetariano',
        emoji: null,
        parentId: 10,
      },
    ],
  },
  {
    id: 38,
    description: 'Lifestyle',
    description_en: 'Lifestyle',
    description_es: 'Estilo de vida',
    emoji: '😎',
    parentId: null,
    children: [
      {
        id: 128,
        description: 'Astrologia',
        description_en: 'Astrology',
        description_es: 'Astrología',
        emoji: null,
        parentId: 38,
      },
      {
        id: 133,
        description: 'Dicas de Passeio',
        description_en: 'Walking Tips',
        description_es: 'Consejos Para Caminar',
        emoji: null,
        parentId: 38,
      },
      {
        id: 127,
        description: 'Fotografia',
        description_en: 'Photography',
        description_es: 'Fotografía',
        emoji: null,
        parentId: 38,
      },
      {
        id: 125,
        description: 'Hobbies',
        description_en: 'Hobbies',
        description_es: 'Aficiones',
        emoji: null,
        parentId: 38,
      },
      {
        id: 126,
        description: 'Lazer',
        description_en: 'Leisure',
        description_es: 'Ocio',
        emoji: null,
        parentId: 38,
      },
      {
        id: 132,
        description: 'Rotina Pessoal',
        description_en: 'Personal routine',
        description_es: 'Rutina Personal',
        emoji: null,
        parentId: 38,
      },
      {
        id: 129,
        description: 'Sexualidade',
        description_en: 'Sexuality',
        description_es: 'Sexualidad',
        emoji: null,
        parentId: 38,
      },
      {
        id: 130,
        description: 'Tatuagem',
        description_en: 'Tattoo',
        description_es: 'Tatuaje',
        emoji: null,
        parentId: 38,
      },
      {
        id: 50,
        description: 'Veganismo',
        description_en: 'Veganism',
        description_es: 'Veganismo',
        emoji: null,
        parentId: 38,
      },
      {
        id: 131,
        description: 'Yoga e Meditação',
        description_en: 'Yoga and Meditation',
        description_es: 'Yoga Y Meditación',
        emoji: null,
        parentId: 38,
      },
    ],
  },
  {
    id: 245,
    description: 'Marketing',
    description_en: 'Marketing',
    description_es: 'Márketing',
    emoji: '📢',
    parentId: null,
    children: [
      {
        id: 249,
        description: 'CRM',
        description_en: 'CRM',
        description_es: 'CRM',
        emoji: null,
        parentId: 245,
      },
      {
        id: 248,
        description: 'Marketing de Produto',
        description_en: 'Mercadeo De Producto',
        description_es: 'Mercadeo De Producto',
        emoji: null,
        parentId: 245,
      },
      {
        id: 246,
        description: 'Marketing Digital',
        description_en: 'Digital Marketing',
        description_es: 'Marketing Digital',
        emoji: null,
        parentId: 245,
      },
      {
        id: 247,
        description: 'Marketing Pessoal',
        description_en: 'Personal Marketing',
        description_es: 'Mercadotecnia Personal',
        emoji: null,
        parentId: 245,
      },
      {
        id: 250,
        description: 'Tráfego Pago',
        description_en: 'Paid Traffic',
        description_es: 'Tráfico pagado',
        emoji: null,
        parentId: 245,
      },
    ],
  },
  {
    id: 26,
    description: 'Moda',
    description_en: 'Fashion',
    description_es: 'Moda',
    emoji: '👠',
    parentId: null,
    children: [
      {
        id: 213,
        description: 'Acessórios',
        description_en: 'Accessories',
        description_es: 'Accesorios',
        emoji: null,
        parentId: 26,
      },
      {
        id: 32,
        description: 'Artigos de luxo',
        description_en: 'Luxury Goods',
        description_es: 'Artículos de lujo',
        emoji: null,
        parentId: 26,
      },
      {
        id: 212,
        description: 'Calçados',
        description_en: 'Footwear',
        description_es: 'Calzado',
        emoji: null,
        parentId: 26,
      },
      {
        id: 216,
        description: 'Dicas de estilo',
        description_en: 'Style Tips',
        description_es: 'Consejos De Estilo',
        emoji: null,
        parentId: 26,
      },
      {
        id: 209,
        description: 'Fashion design',
        description_en: 'Fashion design',
        description_es: 'Diseño De Moda',
        emoji: null,
        parentId: 26,
      },
      {
        id: 215,
        description: 'Promoções',
        description_en: 'Promotions',
        description_es: 'Promociones',
        emoji: null,
        parentId: 26,
      },
      {
        id: 208,
        description: 'Roupas',
        description_en: 'Clothes',
        description_es: 'Ropa',
        emoji: null,
        parentId: 26,
      },
      {
        id: 210,
        description: 'Roupas de crianças',
        description_en: 'Children clothes',
        description_es: 'Ropa De Niños',
        emoji: null,
        parentId: 26,
      },
      {
        id: 214,
        description: 'Sustentável',
        description_en: 'Sustainable',
        description_es: 'Sostenible',
        emoji: null,
        parentId: 26,
      },
      {
        id: 211,
        description: 'Venda Online',
        description_en: 'Online sale',
        description_es: 'Venta Online',
        emoji: null,
        parentId: 26,
      },
    ],
  },
  {
    id: 28,
    description: 'Música',
    description_en: 'Music',
    description_es: 'Canción',
    emoji: '🎵',
    parentId: null,
    children: [
      {
        id: 134,
        description: 'Concertos',
        description_en: 'Concerts',
        description_es: 'Conciertos',
        emoji: null,
        parentId: 28,
      },
      {
        id: 136,
        description: 'Festas',
        description_en: 'Parties',
        description_es: 'Fiestas',
        emoji: null,
        parentId: 28,
      },
      {
        id: 135,
        description: 'Festivais',
        description_en: 'Festivals',
        description_es: 'Festivales',
        emoji: null,
        parentId: 28,
      },
      {
        id: 137,
        description: 'Músicos',
        description_en: 'Musicians',
        description_es: 'Músicos',
        emoji: null,
        parentId: 28,
      },
    ],
  },
  {
    id: 44,
    description: 'Negócios',
    description_en: 'Business',
    description_es: 'Negocio',
    emoji: '👨‍⚖️',
    parentId: null,
    children: [
      {
        id: 82,
        description: 'Agronegócio',
        description_en: 'Agrobusiness',
        description_es: 'Agroindustria',
        emoji: null,
        parentId: 44,
      },
      {
        id: 79,
        description: 'Coach e Cursos',
        description_en: 'Coach Courses',
        description_es: 'Entrenador y cursos',
        emoji: null,
        parentId: 44,
      },
      {
        id: 76,
        description: 'Consultoria',
        description_en: 'Consultancy',
        description_es: 'Consultoría',
        emoji: null,
        parentId: 44,
      },
      {
        id: 78,
        description: 'Empreendedorismo da Beleza',
        description_en: 'Entrepreneurship Beauty',
        description_es: 'Emprendimiento de Belleza',
        emoji: null,
        parentId: 44,
      },
      {
        id: 75,
        description: 'Empregos',
        description_en: 'Jobs',
        description_es: 'Trabajos',
        emoji: null,
        parentId: 44,
      },
      {
        id: 56,
        description: 'Energia',
        description_en: 'Energy',
        description_es: 'Energía',
        emoji: null,
        parentId: 44,
      },
      {
        id: 81,
        description: 'Infoproduto',
        description_en: 'Infoproduct',
        description_es: 'Infoproducto',
        emoji: null,
        parentId: 44,
      },
      {
        id: 80,
        description: 'Palestrante',
        description_en: 'Panelist',
        description_es: 'Miembro Del Jurado',
        emoji: null,
        parentId: 44,
      },
      {
        id: 77,
        description: 'Startup e Empreendedorismo',
        description_en: 'Startup and Entrepreneurship',
        description_es: 'Startup y Emprendimiento',
        emoji: null,
        parentId: 44,
      },
    ],
  },
  {
    id: 251,
    description: 'Notícias',
    description_en: 'News',
    description_es: 'Notícias',
    emoji: '📰',
    parentId: null,
    children: [],
  },
  {
    id: 9,
    description: 'Outros',
    description_en: 'Others',
    description_es: 'Otros',
    emoji: '🤷‍♂️',
    parentId: null,
    children: [],
  },
  {
    id: 6,
    description: 'Pets',
    description_en: 'Pets',
    description_es: 'Mascotas',
    emoji: '🐶',
    parentId: null,
    children: [
      {
        id: 168,
        description: 'Animais Silvestre',
        description_en: 'Wild animals',
        description_es: 'Animales Salvajes',
        emoji: null,
        parentId: 6,
      },
      {
        id: 170,
        description: 'Cachorros',
        description_en: 'Dogs',
        description_es: 'Perros',
        emoji: null,
        parentId: 6,
      },
      {
        id: 169,
        description: 'Gatos',
        description_en: 'Cats',
        description_es: 'Gatos',
        emoji: null,
        parentId: 6,
      },
    ],
  },
  {
    id: 35,
    description: 'Saúde e medicina',
    description_en: 'Health & Medicine',
    description_es: 'Salud y Medicina',
    emoji: '🩺',
    parentId: null,
    children: [
      {
        id: 120,
        description: 'Exercícios Fisícos',
        description_en: 'Physical exercises',
        description_es: 'Ejercicios Físicos',
        emoji: null,
        parentId: 35,
      },
      {
        id: 121,
        description: 'Exercícios Mentais',
        description_en: 'Mental exercises',
        description_es: 'Ejercicios Mentales',
        emoji: null,
        parentId: 35,
      },
      {
        id: 122,
        description: 'Farmacologia',
        description_en: 'Pharmacology',
        description_es: 'Farmacología',
        emoji: null,
        parentId: 35,
      },
      {
        id: 124,
        description: 'Medicina Alternativa',
        description_en: 'Alternative medicine',
        description_es: 'Medicina Alternativa',
        emoji: null,
        parentId: 35,
      },
      {
        id: 118,
        description: 'Médicos',
        description_en: 'Doctors',
        description_es: 'Médicos',
        emoji: null,
        parentId: 35,
      },
      {
        id: 119,
        description: 'Nutrição',
        description_en: 'Nutrition',
        description_es: 'Nutrición',
        emoji: null,
        parentId: 35,
      },
      {
        id: 123,
        description: 'Psicologia',
        description_en: 'Psychology',
        description_es: 'Psicología',
        emoji: null,
        parentId: 35,
      },
    ],
  },
  {
    id: 198,
    description: 'Sociedade',
    description_en: 'Society',
    description_es: 'Sociedad',
    emoji: '🏙️',
    parentId: null,
    children: [
      {
        id: 201,
        description: 'Caridade',
        description_en: 'Charity',
        description_es: 'Caridad',
        emoji: null,
        parentId: 198,
      },
      {
        id: 199,
        description: 'Comunidades',
        description_en: 'Communities',
        description_es: 'Comunidades',
        emoji: null,
        parentId: 198,
      },
      {
        id: 202,
        description: 'Leis',
        description_en: 'Laws',
        description_es: 'Leyes',
        emoji: null,
        parentId: 198,
      },
      {
        id: 203,
        description: 'Militar',
        description_en: 'Military',
        description_es: 'Militar',
        emoji: null,
        parentId: 198,
      },
      {
        id: 200,
        description: 'Organização',
        description_en: 'Organization',
        description_es: 'Organización',
        emoji: null,
        parentId: 198,
      },
      {
        id: 204,
        description: 'Política',
        description_en: 'Politics',
        description_es: 'Política',
        emoji: null,
        parentId: 198,
      },
      {
        id: 207,
        description: 'Política Internacional',
        description_en: 'International policy',
        description_es: 'Política Internacional',
        emoji: null,
        parentId: 198,
      },
      {
        id: 205,
        description: 'Religião',
        description_en: 'Religion',
        description_es: 'Religión',
        emoji: null,
        parentId: 198,
      },
      {
        id: 206,
        description: 'Voluntariado',
        description_en: 'Volunteering',
        description_es: 'Trabajar Como Voluntario',
        emoji: null,
        parentId: 198,
      },
    ],
  },
  {
    id: 8,
    description: 'Tecnologia',
    description_en: 'Technology',
    description_es: 'Tecnología',
    emoji: '💻',
    parentId: null,
    children: [
      {
        id: 161,
        description: 'Ciência',
        description_en: 'Science',
        description_es: 'Ciencias',
        emoji: null,
        parentId: 8,
      },
      {
        id: 158,
        description: 'Computadores',
        description_en: 'Computers',
        description_es: 'Ordenadores',
        emoji: null,
        parentId: 8,
      },
      {
        id: 159,
        description: 'Eletro e Eletrônico',
        description_en: 'Electro and Electronic',
        description_es: 'Electro y electronico',
        emoji: null,
        parentId: 8,
      },
      {
        id: 162,
        description: 'Gadgets',
        description_en: 'Gadgets',
        description_es: 'Artilugio',
        emoji: null,
        parentId: 8,
      },
      {
        id: 163,
        description: 'Programação',
        description_en: 'Programming',
        description_es: 'Programación',
        emoji: null,
        parentId: 8,
      },
      {
        id: 164,
        description: 'Smartphones',
        description_en: 'Smartphones',
        description_es: 'Teléfonos inteligentes',
        emoji: null,
        parentId: 8,
      },
      {
        id: 165,
        description: 'Tablets',
        description_en: 'Tablets',
        description_es: 'Tabletas',
        emoji: null,
        parentId: 8,
      },
      {
        id: 160,
        description: 'Telecom',
        description_en: 'Telecom',
        description_es: 'Telecom',
        emoji: null,
        parentId: 8,
      },
    ],
  },
  {
    id: 57,
    description: 'Varejo',
    description_en: 'Retail',
    description_es: 'Venta minorista',
    emoji: '📦',
    parentId: null,
    children: [],
  },
  {
    id: 41,
    description: 'Viagens e turismo',
    description_en: 'Travel',
    description_es: 'Viaje y Turismo',
    emoji: '✈️',
    parentId: null,
    children: [
      {
        id: 219,
        description: 'Cruzeiros',
        description_en: 'Cruises',
        description_es: 'Cruceros',
        emoji: null,
        parentId: 41,
      },
      {
        id: 220,
        description: 'Ecoturismo',
        description_en: 'Ecotourism',
        description_es: 'Ecoturismo',
        emoji: null,
        parentId: 41,
      },
      {
        id: 225,
        description: 'Férias',
        description_en: 'Vacation',
        description_es: 'Vacaciones',
        emoji: null,
        parentId: 41,
      },
      {
        id: 221,
        description: 'Hoteis',
        description_en: 'Hotels',
        description_es: 'Hoteles',
        emoji: null,
        parentId: 41,
      },
      {
        id: 222,
        description: 'Montanhas',
        description_en: 'Montañas',
        description_es: 'Montañas',
        emoji: null,
        parentId: 41,
      },
      {
        id: 223,
        description: 'Natureza',
        description_en: 'Nature',
        description_es: 'Naturaleza',
        emoji: null,
        parentId: 41,
      },
      {
        id: 224,
        description: 'Parques Temáticos',
        description_en: 'Parques Temáticos',
        description_es: 'Parques temáticos',
        emoji: null,
        parentId: 41,
      },
      {
        id: 217,
        description: 'Passagens Aéreas',
        description_en: 'Airline Tickets',
        description_es: 'Pasajes Aéreos',
        emoji: null,
        parentId: 41,
      },
      {
        id: 218,
        description: 'Praias',
        description_en: 'Beaches',
        description_es: 'Playas',
        emoji: null,
        parentId: 41,
      },
      {
        id: 226,
        description: 'Turismo Cultural',
        description_en: 'Cultural Tourism',
        description_es: 'Turismo Cultural',
        emoji: null,
        parentId: 41,
      },
      {
        id: 227,
        description: 'Turismo Náutico',
        description_en: 'Nautical Tourism',
        description_es: 'Turismo náutico',
        emoji: null,
        parentId: 41,
      },
    ],
  },
]
